<div class="modal right" id="newChat" tabindex="-1" role="dialog" aria-labelledby="newChatLabel">
    <div class="modal-dialog" role="document">
        <div class="modal-content" id="print-content">
            <div class="modal-header hide-print">
                <div class="modal-title">
					<h4 id="newChatLabel" ng-if="!newConversation.id">New Converversation</h4>
                    <h4 id="newChatLabel" ng-if="newConversation.id">Edit Converversation</h4>
                </div>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <i class="icon-close-circle"></i>
                </button>
            </div>
            <div class="modal-body order-detail-page">
                <div class="modal-body-container">
					<div class="tab-content">
						<div class="tab-pane active">
							<div class="row">
								<div class="col-md-12">
									<form ng-submit="save()" class="form-horizontal allcp-form">
				
										<div class="form-group floating">
											<select 
												ng-model="newConversation.worker_id" 
												class="form-control"
												
												ng-options="worker.id as worker.full_name for worker in workers">
												<option value="">Select Driver</option>
											</select>

											<label>Driver</label>
										</div>

										<div class="form-group floating">
											<input type="text" ng-model="newConversation.message" class="form-control input-md" placeholder="Message" required>
											<label>Message</label>
										</div>

										<div class="form-group floating pln">
											<div class="col-md-12 pln">
												<button type="submit" class="hod-button blue">
													<span ng-if="!newConversation.id">CREATE</span>
                    								<span ng-if="newConversation.id">UPDATE</span>
												</a>
											</div>
										</div>
									</form>
								</div>
							</div>
						</div>
					</div>
				</div>
            </div>
        </div>
    </div>
</div>
